import { ProductMoreInformation } from '@/types'

export const processMoreInfo = (moreInfoArray: ProductMoreInformation[]) =>
  moreInfoArray
    .filter(({ content }) => content != undefined)
    .map(({ heading, content }) => {
      const listWrappedContent = content
        .split('*')
        .filter((item) => item.trim() !== '')
        .map((item) => `<li>${item}</li>`)
        .join('')
      return { heading: heading, content: `<more-info><ul>${listWrappedContent}</ul></more-info>` }
    })
